import bdServices from '../bd-services'

const api_ducter_movenergy = {}

api_ducter_movenergy.sendData = async function (form,id,terminal) {

  let formData = new FormData()
  formData.append('id', id)
  formData.append('terminal', terminal)
  formData.append('form', JSON.stringify(form))

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data:formData,
    url: '/servidores/tpa/sca/sendDataNomcar.php'
  }


  const data = await bdServices(options)
    .then((res)=>{
      console.log('ducter_movenergyServices',res)
    })
    .catch((err) => {
      console.error('ducter_movenergyServices',err)
    })
  return data
}

export default api_ducter_movenergy



// WEBPACK FOOTER //
// ./src/services/sca/apiDucterMoveEnergy.js